import api from 'api';
import { ENotice, ERef, ERequestTypes } from 'lib/types';
import { ResponseOrError, wrapError, wrapSuccess } from 'lib/types/responses';

/**
 * Send a request to the backend requesting to cancel or refund the active
 * invoice for a notice.
 */
export const cancelOrRefundInvoiceForNotice = async (
  notice: ERef<ENotice>,
  voidReason?: string
): Promise<ResponseOrError<void>> => {
  const reqBody: ERequestTypes['payments/cancel-invoice'] = {
    noticeId: notice.id,
    voidReason
  };
  const result = await api.safePost('payments/cancel-invoice', reqBody);
  if (result.error !== null) {
    return wrapError(new Error(result.error));
  }
  return wrapSuccess(undefined);
};
